import React from 'react';
import { Stack, Typography } from '@mui/material';

import BetaChip from '../utils/BetaChip';

// The Studio page's visible name, shown above the form name. "Form Studio" is the page's name,
// not part of the beta label: when Form Studio leaves beta only the chip is removed.
const FormStudioPageName = () => (
  <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 0.5 }}>
    <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
      Form Studio
    </Typography>
    <BetaChip service="Form Studio" />
  </Stack>
);

export default FormStudioPageName;
